import { toDictionary } from "@tokenterminal/core/utils/toDictionary"
import { useMetricsConfigurationList } from "modules/projects/hooks/useMetricsConfigurationList"

const useMetricsConfigurationBySlug = (slug?: string) => {
  const { data: metricConfigurations = [] } = useMetricsConfigurationList()
  if (!slug) return undefined

  const metricConfigurationsBySlug = toDictionary(metricConfigurations, "slug")
  return metricConfigurationsBySlug.get(slug)
}

export const useMetricsConfigurationBySlugs = (slugs?: string[]) => {
  const { data: metricConfigurations = [] } = useMetricsConfigurationList()
  if (!slugs?.length) return []

  const metricConfigurationsBySlug = toDictionary(metricConfigurations, "slug")
  return slugs
    .map((slug) => metricConfigurationsBySlug.get(slug))
    .filter(Boolean)
}

export default useMetricsConfigurationBySlug
